import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import pageStore from 'stores/BackInStock/PageStore';
import * as constants from 'Constants';
import * as utils from 'Utils';
import { setFieldValues } from 'stores/Utils';


class SubmitModalStore {

  @setter @observable display;
  @setter @observable error;

  @setter @observable email;
  @setter @observable variantIds;
  @setter @toggle @observable subscribeToMarketing;

  @setter @observable isSubmitting;

  constructor() {
    this.reset();
  }

  @action reset() {
    this.resetFields();
    this.display = false;
    this.error = "";

    this.isSubmitting = false;
  }

  @action resetFields() {
    this.email = "";
    this.variantIds = [];
    this.subscribeToMarketing = false;
  }

  @computed get displayError() {
    return this.error ? true : false;
  }

  @action resetError() {
    this.error = "";
  }

  @action show() {
    this.resetError();
    this.display = true;
  }

  @action hide() {
    if (utils.isPreview()) return;
    this.display = false;
  }

  @computed get submitBtnText() {
    if (this.isSubmitting) return "Submitting ...";
    return pageStore.modalConfig.btnText;
  }

  @computed get disableSubmitBtn() {
    return this.isSubmitting;
  }

  @computed get variantSelectOptions() {
    const variants = pageStore.product.variants.filter((variant) => variant.outOfStock);
    const values = variants.map((variant) => {
      return {
        'value': variant.id,
        'label': variant.title,
      };
    });

    return values;
  }
}

const submitModalStore = new SubmitModalStore();
export default submitModalStore;
export { SubmitModalStore };
